var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[(_vm.column.component && _vm.column.value)?_c(_vm.column.component,{tag:"component",attrs:{"model":_vm.model,"column":_vm.column,"store-name":_vm.storeName}}):_c('span',[_vm._v("\n        "+_vm._s(_vm.mappedValue)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }